var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCloudUploadImageBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.5 12.0234V21.0234M12.5 12.0234L9.99996 14.0234M12.5 12.0234L15 14.0234M5.53396 9.14038C4.58817 9.37837 3.76184 9.95354 3.21021 10.7578C2.65859 11.5621 2.41964 12.5401 2.53827 13.5082C2.65689 14.4762 3.12492 15.3676 3.85443 16.0149C4.58393 16.6622 5.52469 17.0208 6.49996 17.0234H7.49996",
    stroke: "#272E35",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.3299 7.1614C15.9881 5.80797 15.1445 4.63514 13.97 3.88066C12.7956 3.12617 11.3782 2.84649 10.0052 3.0983C8.63215 3.35012 7.40625 4.11458 6.57598 5.23674C5.7457 6.35889 5.37318 7.75477 5.53392 9.1414C5.53392 9.1414 5.68692 10.0234 5.99992 10.5234",
    stroke: "#272E35",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M17.5 17.0234C18.206 17.023 18.904 16.873 19.5479 16.5833C20.1917 16.2936 20.767 15.8709 21.2357 15.3429C21.7045 14.8149 22.0561 14.1936 22.2674 13.52C22.4787 12.8463 22.545 12.1355 22.4618 11.4344C22.3786 10.7333 22.1479 10.0577 21.7848 9.45218C21.4217 8.84665 20.9345 8.32488 20.3552 7.92122C19.776 7.51756 19.1178 7.24115 18.424 7.1102C17.7302 6.97924 17.0166 6.9967 16.33 7.16144L15 7.52344",
    stroke: "#272E35",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloudUploadImageBlack);
export default __webpack_public_path__ + "static/media/icon_cloud-upload-image-black.95c9278c1b8fa8d02311e297b0902230.svg";
export { ForwardRef as ReactComponent };